module.exports = __webpack_public_path__ + "img/about-me-1.db1220d2.svg";